export class GridTitleConfig {
  constructor(public title: string, public isLink?: boolean, public event?: GridTitleConfigEvent) {}
}

export class GridTitleConfigEvent {
  public click: string;

  public withClickEvent(clickEventName: string): this {
    this.click = clickEventName;

    return this;
  }
}
